import React from 'react';
import ImmigrationCalculator from './ImmigrationCalculator';

function TestAdmissibilite() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Test du Calculateur d'Admissibilité</h1>
      <ImmigrationCalculator />
    </div>
  );
}

export default TestAdmissibilite;